import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {

        // sliders
        var splideElements = document.querySelectorAll('.photo-gallery-section__bna__slider');

        if (splideElements.length > 0) {
            splideElements.forEach(function (splideElement) {
                const counter = splideElement.querySelector('.slider-info .slider-numbers');

                // Pass each splideElement to the Splide constructor
                var splide = new Splide(splideElement, {
                    type: 'slider',
                    speed: 1000,
                    arrows: true,
                    pagination: false,
                    rewind: false,
                    perPage: 2,
                    perMove: 1,
                    gap: 15,
                    waitForTransition: false,
                    arrowPath: 'M9.75009 17.9394L0.840088 9.03939L9.75009 0.129395L11.1601 1.53939L3.67009 9.03939L11.1601 16.5294L9.75009 17.9394Z',
                    breakpoints: {
                        768: {
                            perPage: 1,
                        }
                    }
                });
                splide.mount();

                // Function to update the counter
                function updateCounter(splide) {
                    if (counter) {
                        var currentSlide = splide.index + 1;  // +1 because index is 0-based
                        var totalSlides = splide.length;
                        counter.textContent = `${currentSlide}/${totalSlides}`;
                    }
                }

                // Initial counter update
                updateCounter(splide);

                // Update counter on slide change
                splide.on('move', function () {
                    updateCounter(splide);
                });
            });
        }
    }
    
    if (window.acf) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction('render_block_preview/type=photo-gallery-section', initializeBlock);
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});
